import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from "../components/ui/button.jsx"; // --- ADDED: Import Button ---

const ForFounders = () => {
    return (
        <motion.div
            // --- UPDATED: Use standard background and padding ---
            className="bg-background py-12 md:py-16"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }} // Added transition
        >
            {/* --- ADDED: Container --- */}
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
                    {/* Left Column: Text */}
                    <motion.div
                        initial={{ opacity: 0, x: -30 }}
                        // --- UPDATED: Use whileInView for scroll-triggered animation ---
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, amount: 0.2 }} // Added viewport
                        transition={{ duration: 0.7, delay: 0.2 }}
                    >
                        <h1 className="text-4xl md:text-5xl font-bold text-foreground leading-tight font-serif"> {/* Use theme color, font-serif */}
                            For Founders
                        </h1>
                        <div className="mt-12 space-y-10">
                            <div>
                                <h3 className="text-3xl font-bold text-foreground mb-4">What We Look For</h3>
                                {/* --- UPDATED: Use theme text color --- */}
                                <ul className="list-disc list-outside space-y-3 pl-5 text-muted-foreground text-lg leading-relaxed"> {/* Removed font-sans, uses default */}
                                    <li>Contrarian insight with compounding distribution advantage.</li>
                                    <li>Evidence of velocity: shipping cadence, customer pull, and learning throughput.</li>
                                    <li>Clear technical or regulatory edge that widens over time.</li>
                                </ul>
                            </div>

                            <div>
                                <h3 className="text-3xl font-bold text-foreground mb-4">Investment Stages</h3>
                                {/* --- UPDATED: Mention Amama Bypass --- */}
                                <p className="text-muted-foreground text-lg leading-relaxed"> {/* Removed font-sans */}
                                    Pre-seed to Series A, with reserves for breakout follow-ons where traction meets defensibility. We also guide founders on leveraging <b>Amama Bypass</b> for complementary non-dilutive funding.
                                </p>
                            </div>
                        </div>
                    </motion.div>

                    {/* Right Column: Contact CTA */}
                    <motion.div
                        // --- UPDATED: Use card styling like Contact form ---
                        className="bg-card p-8 md:p-10 rounded-2xl shadow-lg border border-border"
                        initial={{ opacity: 0, x: 30 }}
                        // --- UPDATED: Use whileInView ---
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, amount: 0.2 }} // Added viewport
                        transition={{ duration: 0.7, delay: 0.4 }}
                    >
                        <h2 className="text-3xl font-bold text-foreground mb-4">How to Engage</h2>
                        {/* --- UPDATED: Use theme text color --- */}
                        <p className="text-muted-foreground text-lg mb-6 leading-relaxed"> {/* Removed font-sans */}
                            Share a 8–12 slide narrative: problem, wedge, product, GTM, traction, roadmap, economics, team.
                        </p>
                        {/* --- UPDATED: Use theme text color --- */}
                        <p className="text-muted-foreground text-lg mb-8 leading-relaxed"> {/* Removed font-sans */}
                            Optional: 3-minute product walk-through or live sandbox.
                        </p>
                        <motion.div // Keep hover/tap animation wrapper for Button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <Link to="/contact">
                                {/* --- UPDATED: Use Button component --- */}
                                {/* Use variant="hero" and size="lg" like CTABand */}
                                <Button variant="hero" size="lg" className="w-full">
                                    Share Your Deck
                                </Button>
                            </Link>
                        </motion.div>
                    </motion.div>
                </div>
            </div>
        </motion.div>
    );
};

export default ForFounders;